import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { RootState } from '../../../store';
import { createCalculation, showNewCalculationDialog } from '../redux/calculationSlices';

const mapStateToProps = (state: RootState) => ({
    pricelistId: state.calculation.selectedCalculationPricelist,
    isCreateCalculationDialogOpen: state.calculation.showCreateNewCalculationDialog
});

type Props = ReturnType<typeof mapStateToProps>;

const CreateCalculationDialog = ({ pricelistId, isCreateCalculationDialogOpen }: Props) => {
    const dispatch = useDispatch();
    const dispatchHideNewCalculationDialog = () => {
        dispatch(showNewCalculationDialog(false));
    };

    const [formState, setState] = useState({
        name: ''
    });

    const handleNameChange = (inputValue: string) => {
        setState({
            ...formState,
            name: inputValue
        });
    };

    const dispatchCreateNewCalculation = () => {
        const newCalculation = {
            name: formState.name,
            pricelistId: pricelistId
        };

        dispatch(createCalculation.request(newCalculation));
        setState({ name: '' });
    };

    return (
        <Dialog
            onClose={dispatchHideNewCalculationDialog}
            aria-labelledby="simple-dialog-title"
            open={isCreateCalculationDialogOpen}
        >
            <DialogTitle id="simple-dialog-title">Create calculation</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Name"
                    type="text"
                    onChange={e => handleNameChange(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={dispatchHideNewCalculationDialog} color="primary">
                    Close
                </Button>
                <Button onClick={dispatchCreateNewCalculation} color="primary">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default connect(mapStateToProps)(CreateCalculationDialog);
